﻿import React from "react";
import { ExternalLink } from "lucide-react";
import useAsync from "../../utils/useAsync.js";
import { getReleases } from "../../utils/companyApi.js";
import { fmtLongDate } from "../../utils/format.js";
import { Loading } from "./common.jsx";

export default function TranscriptsTab({ ticker }) {
  const { data, loading, error } = useAsync(() => getReleases(ticker), [ticker]);
  if (loading) return <Loading />;
  const list = Array.isArray(data) ? data : [];

  return (
    <div>
      <div className="card co-card co-table-wrap">
        <h6 className="co-card-title">Earnings releases</h6>
        {(error || !list.length) ? (
          <p className="co-hint">No earnings releases found on SEC EDGAR for this company.</p>
        ) : (
          <table className="co-table co-table-left">
            <thead><tr><th>Date</th><th>Filing</th><th>Documents</th></tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.index}>
                  <td>{fmtLongDate(r.date)}</td>
                  <td><span className="badge-purple">{r.form}</span> Results of operations (Item 2.02)</td>
                  <td>
                    <a href={r.index} target="_blank" rel="noreferrer">All documents <ExternalLink size={12} /></a>
                    {r.doc && <a className="ms-3" href={r.doc} target="_blank" rel="noreferrer">8-K <ExternalLink size={12} /></a>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <p className="co-hint">
        These are the companies' own earnings announcements filed with the SEC (the press release is attached as Exhibit 99.1).
        Call transcripts are licensed content and are not available from a free source.
      </p>
    </div>
  );
}
